// extracted by mini-css-extract-plugin
export var buttonContainer = "NDSSurveyNavigation-module--buttonContainer--84bd7";
export var endSurvey = "NDSSurveyNavigation-module--endSurvey--e702e";
export var navWrapper = "NDSSurveyNavigation-module--navWrapper--7c028";
export var navigationContainer = "NDSSurveyNavigation-module--navigationContainer--35435";
export var navigationContainerCentered = "NDSSurveyNavigation-module--navigationContainerCentered--38f72 NDSSurveyNavigation-module--navigationContainer--35435";
export var nextButton = "NDSSurveyNavigation-module--nextButton--25101";